import React, { useState } from "react";
import PageHeading from "../../components/PageHeading";
import DCard from "../../components/DCard";
import DButton from "../../components/DButton";
import paymentService from "../../services/paymentInfo";
import DSpinner from "../../components/DSpinner";
import { useQuery, useQueryClient } from "react-query";
import Table from "../../components/Table";
import DImage from "../../components/DImage";
import { useNavigate } from "react-router-dom";
import DModal from "../../components/DModal";
import { useDisclosure } from "@chakra-ui/react";
import { toast } from "react-hot-toast";

const columns = [
    {
        Header: "معرف الدفع",
        accessor: "id",
    },
    {
        Header: "المعلومات بالعربية",
        accessor: "text_ar",
    },
    {
        Header: "المعلومات بالانجليزية",
        accessor: "text_en",
    },
    {
        Header: "الصورة",
        accessor: "img",
    },
    {
        Header: "التحكم",
        accessor: "actions",
    },
];
const Payment = ({ title }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [currentAdsId, setCurrentAdsId] = useState();
    const [currentPage, setCurrentPage] = useState(0);
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const { data, isLoading, error } = useQuery(
        ["getPayments", currentPage],
        () => paymentService.getPayments(currentPage + 1)
    );
    const deletePayment = () => {
        onClose();
        paymentService
            .deletePayment(currentAdsId)
            .then(res => {
                toast.success("تم الحذف بنجاح");
                queryClient.refetchQueries("getPayments");
            })
            .catch(err => {
                console.log(err);
                toast.error("فشلت عملية الحذف");
            });
    };
    const formattedData = data => {
        if (data.length > 0) {
            return data.map(d => ({
                ...d,
                img: d.img ? (
                    <div className="relative max-w-[100px] h-[100px] mx-auto">
                        <DImage
                            className={"h-full object-cover w-full"}
                            src={d.img}
                            alt={d.img}
                            load={true}
                        />
                    </div>
                ) : (
                    "------"
                ),
                actions: (
                    <div className="flex items-center justify-center gap-2">
                        <DButton
                            onClick={() => navigate(`/payment-info/${d.id}`)}
                            className={
                                "text-white rounded-[50px_!important] min-w-[100px]"
                            }
                        >
                            تعديل
                        </DButton>
                        <DButton
                            onClick={() => {
                                setCurrentAdsId(d.id);
                                onOpen();
                            }}
                            bgColor="danger"
                            className={
                                "text-white rounded-[50px_!important] min-w-[100px]"
                            }
                        >
                            حذف
                        </DButton>
                    </div>
                ),
            }));
        }
        return [];
    };
    return (
        <div className="payment">
            <DModal
                isOpen={isOpen}
                onClose={onClose}
                modelType="delete"
                clickHandler={deletePayment}
                bodyText="هل انت متأكد انك تريد حذف هذا السجل؟"
            />
            <PageHeading>{title}</PageHeading>
            <DCard className={isLoading ? "min-h-[400px] relative" : ""}>
                {isLoading ? (
                    <DSpinner />
                ) : (
                    <Table
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalData={error ? 0 : data.data.total}
                        head={columns}
                        body={error ? [] : formattedData(data.data.data)}
                    />
                )}
            </DCard>
        </div>
    );
};

export default Payment;
